export default function getCountryNameFromCountryCode(
  locale: string,
  countryCode: string,
): string {
  const regionNames = new Intl.DisplayNames([locale], { type: 'region' })

  return regionNames.of(countryCode)
}
